export default __webpack_public_path__ + "static/column-span-dark-0a985b715a56be5228e0ede1115e91280e22032338754c4d82e4e06db640ac8c.png";